import React, { PureComponent } from 'react'
import { Icon } from 'antd'
import { observe, observable } from 'mobx'
import { observer } from 'mobx-react'
import './style'
// const interval = 2e3

@observer
class Message extends PureComponent {
  @observable data = {
    visibal: false,
    text: 'init',
    type: 'success'
  }
  constructor (props) {
    super(props)
    this.watch()
  }
  watch () {
    this.observeMessage = observe(this.props.data, (change) => {
      this.data.type = Object.keys(change.added[0])[0]
      this.data.text = change.added[0][this.data.type]
      // 过滤空字符串
      if (!this.data.text) return
      this.data.visibal = true
      const time = change.added[0]['time']
      setTimeout(() => {
        this.data.visibal = false
        const callback = change.added[0]['callback']
        if (callback) callback()
      }, time)
    })
  }
  componentWillUnmount () {
    this.observeMessage()
  }
  render () {
    return (
      <div className={this.data.visibal ? 'message-notice active' : 'message-notice'}>
        {
          this.data.type === 'success' ? (
            <div className='inner'>
              <Icon type='check-circle' />
              <p className='text'>
                {this.data.text}
              </p>
            </div>
          ) : (
            <div className='inner'>
              <Icon type='close-circle' />
              <p className='text'>{this.data.text}</p>
            </div>
          )
        }
      </div>
    )
  }
}

export default
Message



// WEBPACK FOOTER //
// ./src/components/message/Notice.jsx